// extracted by mini-css-extract-plugin
module.exports = {"subscribe":"TableOfContents-styles-module--subscribe--zIpNW"};